import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { Infoblock, OCC_ENDPOINTS, OccInfoblocksResponse } from '@main/infoblock/const';
import { INFOBLOCK_NORMALIZER } from '@main/infoblock/utils';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccInfoblocksService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService,
  ) {}

  load(): Observable<Infoblock[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.infoblocks, {
      queryParams: {
        fields: 'DEFAULT',
      },
    });

    return this.http
      .get<OccInfoblocksResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.infoblocks),
      })
      .pipe(this.converterService.pipeable(INFOBLOCK_NORMALIZER));
  }
}
